
// Hilton Grand Vacations - Member Travel branding.
// Navy / cream palette applied to the shared header, buttons and accents.

import TripsByHiltonLogo from '@share/assets/images/profiles/trips-by-hilton.png';

const HILTON_NAVY = '#002F5F';
const HILTON_GOLD = '#B99653';

export const HiltonWorldwideProfile = {
  buttonColor: HILTON_NAVY,
  buttonTextColor: '#FFFFFF',

  buttonColorReverse: '#FFFFFF',
  buttonTextColorReverse: HILTON_NAVY,

  bogoColor: HILTON_NAVY,
  bogoButtonTextColor: '#FFFFFF',
  getawaysColor: HILTON_NAVY,
  getawaysButtonTextColor: '#FFFFFF',

  mainBackgroundColor: HILTON_NAVY,
  subHeaderColor: HILTON_NAVY,

  mainBorderColor: HILTON_GOLD,

  logo: TripsByHiltonLogo,
  logoSkipWidth: true,
};
